import * as React from "react";
import Box from "@mui/material/Box";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay, EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./swipebanner.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Button, MobileStepper } from "@mui/material";
import { BANNER, TOP_SERIES } from "../../utils/constants";
import { Context } from "../../store";
import useRouting from "../../hooks/useRouting";

function SwipeableBannerStepper({
  type,
  data,
  windowSize,
  section_type,
  ...props
}) {
  const [currentPage, setCurrentPage] = React.useState(1);
  const { routeToSeries } = useRouting();
  const globalState = React.useContext(Context);

  const goToSeries = ({ slug, seriesId }) => {
    routeToSeries({ seriesId, slug });
  };

  const changeActive = (current) => {
    if (type === BANNER) {
      setCurrentPage(current?.realIndex);
    } else {
      setCurrentPage(
        current?.realIndex > data.length / 2 - 1
          ? current?.realIndex - data?.length / 2
          : current?.realIndex
      );
    }
  };

  return (
    <Box
      sx={{ flex: 1, flexGrow: 1, marginTop: 3 }}
      className={styles.wrapper_slider}
    >
      {windowSize >= 768 ? (
        <Swiper
          centeredSlides={true}
          loop={true}
          slidesPerView={"auto"}
          spaceBetween={30}
          onSlideChange={(data) => changeActive(data)}
          initialSlide={1}
          navigation={true}
          modules={[Autoplay, Navigation]}
          className="mySwiper_banner"
          style={{ height: "100%" }}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
        >
          {data?.map((data, index) => {
            const series = type === BANNER ? data : data.series;
            let isUserPremium =
              globalState?.userFullInformation?.user.is_premium;
            return (
              <SwiperSlide
                key={index}
                style={{ height: "100%" }}
                onClick={() =>
                  goToSeries({ slug: series?.slug, seriesId: series?.id })
                }
              >
                <div className={styles.swiper_inner_banner}>
                  <div className={styles.swiper_inner_banner_info}>
                    {/* {series.is_new && <div className={styles.isnew_chip}>
                    New
                  </div>} */}
                    {series?.title_icon ? (
                      <div className={styles.title_image_wrapper}>
                        <img
                          src={series?.title_icon}
                          alt={series?.display_title}
                          className={styles.swiper_banner_title_img}
                        />
                      </div>
                    ) : (
                      <p className={styles.swiper_inner_banner_text}>
                        {series?.display_title}
                      </p>
                    )}
                    {/* {!isUserPremium && <div className={styles.isUserPremium_play}>
                    <span><FontAwesomeIcon icon={faShoppingBag} className={styles.playnow_check} /> Watch free series now </span>
                  </div>} */}
                    {/* <div className={styles.swiper_banner_catrgory}>
                    <span className={styles.swiper_banner_catrgory_time}> <FontAwesomeIcon icon={faClock} className={styles.icon} /> {Math.round(series?.duration_s / 60)}{" "}min</span>
                    <span className={styles.swiper_banner_catrgory_topic}><FontAwesomeIcon icon={faBookOpen} className={styles.icon} />{series?.n_units}{" "}Videos</span>
                    <span className={styles.swiper_banner_catrgory_title}><Image loading="lazy" alt="seekho" src={require('../../public/assets/home-slide/tabler_category.png')} className={styles.icon_img} width={24} height={24} />{series?.category?.title}</span>
                  </div> */}
                    <div className={styles.swiper_banner_catrgory}>
                      <Button className={styles.swiper_banner_catrgory_button}>
                        <FontAwesomeIcon
                          icon={faPlay}
                          className={styles.playnow}
                        />
                        Play
                      </Button>
                    </div>
                  </div>
                  <div
                    className={`${styles.series_details_video_bag} ${
                      type !== TOP_SERIES && styles.all_series_not_top
                    }`}
                  >
                    <div className="relative">
                      <img
                        alt="seekho"
                        src={series?.image}
                        className={styles.series_details_video_thumbanil}
                      />
                      {series?.is_locked && (
                        <img
                          src="/assets/Lock.svg"
                          alt="lock"
                          className="absolute z-10 text-white top-2 mx-auto !left-0 !right-0"
                        />
                      )}
                    </div>
                    <div className={styles.title_icon_image}>
                      <span className={styles.title}>
                        {series?.image_title}
                      </span>
                      <span
                        className={styles.creatorname}
                        style={{ background: series?.creator_color }}
                      >
                        {series?.creator?.name}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div>
          <Swiper
            centeredSlides={true}
            effect={"coverflow"}
            direction="horizontal"
            loop={true}
            slidesPerView={"auto"}
            spaceBetween={30}
            pagination={true}
            onSlideChange={(data) => changeActive(data)}
            initialSlide={1}
            navigation={false}
            modules={[Autoplay, EffectCoverflow]}
            className="mySwiper_banner"
            style={{ height: "100%" }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 20,
              depth: 500,
              modifier: 1,
              slideShadows: true,
            }}
          >
            {data?.map((data, index) => {
              const series = type === BANNER ? data : data.series;
              return (
                <SwiperSlide
                  key={index}
                  style={{ height: "100%" }}
                  onClick={() =>
                    goToSeries({ slug: series.slug, seriesId: series?.id })
                  }
                >
                  <div className={styles.swiper_inner_banner_mobile}>
                    <div className={styles.swiper_inner_banner_info_mobile}>
                      {/* {series.is_new && <div className={styles.isnew_chip}>
                      New
                    </div>} */}
                    </div>
                    <div
                      className={`${styles.series_details_video_bag_mobile} ${
                        type !== TOP_SERIES && styles.all_series_not_top
                      }`}
                    >
                      <img
                        alt={series?.display_title}
                        src={series?.image}
                        className={styles.series_details_video_thumbanil}
                      />
                      {series?.is_locked && (
                        <img
                          src="/assets/Lock.svg"
                          alt="lock"
                          className="absolute z-10 text-white top-2 mx-auto !left-0 !right-0"
                        />
                      )}
                      <div className={styles.title_icon_image}>
                        <span className={styles.title}>
                          {series?.image_title}
                        </span>
                        <span
                          className={styles.creatorname}
                          style={{ background: series?.creator_color }}
                        >
                          {series?.creator?.name}
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className={styles.swiper_banner_flex}>
            {/* {!isUserPremium && <div className={styles.isUserPremium_play}>
              <span><FontAwesomeIcon icon={faShoppingBag} className={styles.playnow_check} /> Watch free series now </span>
            </div>} */}
            {/* <div className={styles.swiper_banner_catrgory}>
              <span className={styles.swiper_banner_catrgory_time}> <FontAwesomeIcon icon={faClock} className={styles.icon} /> {Math.round(currentData?.duration_s / 60)}{" "}min</span>
              <span className={styles.swiper_banner_catrgory_topic}><FontAwesomeIcon icon={faBookOpen} className={styles.icon} />{currentData?.n_units}{" "}Videos</span>
              <span className={styles.swiper_banner_catrgory_title}><Image loading="lazy" src={require('../../public/assets/home-slide/tabler_category.png')} className={styles.icon_img} width={24} height={24} />{currentData?.category?.title}</span>
            </div> */}
            {/* <div className={styles.swiper_banner_catrgory}>
              <Button className={styles.swiper_banner_catrgory_button} onClick={() => goToSeries(currentData?.is_premium, currentData.slug)}><FontAwesomeIcon icon={faPlay} className={styles.playnow} />Play</Button>
            </div> */}
          </div>
        </div>
      )}
      <div className="hidden lg:block mt-2">
        {data?.length > 0 && (
          <MobileStepper
            className={styles.dots_stepper}
            variant="dots"
            steps={type === BANNER ? data?.length : data?.length / 2}
            position="static"
            activeStep={currentPage}
            sx={{ maxWidth: 400, flexGrow: 1, margin: "auto" }}
          ></MobileStepper>
        )}
      </div>
    </Box>
  );
}

export default SwipeableBannerStepper;
